import { ListValueProp } from "@hitachivantara/uikit-react-core";
import {
  CreateIncidentActionAttribute,
  EventType,
  IncidentType,
} from "lib/api";
import { MapPropertiesDataRow } from "./MapPropertiesTable/MapPropertiesTable";

export const createPayload = (
  currentMapProperties:
    | Record<string, CreateIncidentActionAttribute>
    | undefined,
  incidentPropertyKey: string,
  entityPropertyValue: ListValueProp
): Record<string, CreateIncidentActionAttribute> => {
  const currentPayload = currentMapProperties || {};
  const newPayload = { ...currentPayload };
  if (
    newPayload[incidentPropertyKey] === undefined ||
    newPayload[incidentPropertyKey]?.value !== entityPropertyValue?.id
  ) {
    if (entityPropertyValue?.id != null) {
      newPayload[incidentPropertyKey] = {
        value: entityPropertyValue?.id,
      };
    } else {
      delete newPayload[incidentPropertyKey];
    }
  } else {
    delete newPayload[incidentPropertyKey];
  }
  return newPayload;
};

export const createMapPropertiesTableData = (
  incidentType: IncidentType | undefined,
  eventType: EventType | undefined,
  currentMapProperties:
    | Record<string, CreateIncidentActionAttribute>
    | undefined
): MapPropertiesDataRow[] => {
  if (incidentType === undefined || eventType === undefined) return [];
  const entityPropertyInitialValues = currentMapProperties || {};
  const newData = Object.keys(incidentType.attributes).map((key) => {
    const incidentPropertyType = incidentType.attributes[key].type;
    const selectedEntityProperty = entityPropertyInitialValues[key];
    const entityProperty = Object.keys(eventType.attributes ?? [])
      .map((eventKey) => {
        return {
          id: eventKey,
          label: eventType.attributes[eventKey].label,
          type: eventType.attributes[eventKey].type,
          selected: selectedEntityProperty?.value === eventKey,
        };
      })
      .filter(
        (entityPropertyValue) =>
          entityPropertyValue.type.toLowerCase() ===
          incidentPropertyType.toLowerCase()
      );
    return {
      id: key,
      incidentProperty: incidentType.attributes[key].label,
      incidentPropertyType,
      entityProperty,
      entityPropertyType: incidentPropertyType,
    };
  });
  return newData;
};
